import { render, staticRenderFns } from "./well.vue?vue&type=template&id=69b1915b&scoped=true"
import script from "./well.vue?vue&type=script&lang=js"
export * from "./well.vue?vue&type=script&lang=js"
import style0 from "./well.vue?vue&type=style&index=0&id=69b1915b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b1915b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b1915b')) {
      api.createRecord('69b1915b', component.options)
    } else {
      api.reload('69b1915b', component.options)
    }
    module.hot.accept("./well.vue?vue&type=template&id=69b1915b&scoped=true", function () {
      api.rerender('69b1915b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/well.vue"
export default component.exports